// Simple drag-to-scroll for the thumbnail strip (works with mouse & touch)
(() => {
  const strip =
    document.querySelector('.thumbnail-list.slider') ||
    document.querySelector('.thumbnail-list.slider--tablet-up');

  if (!strip) return;

  let isDown = false;
  let startX = 0;
  let startScroll = 0;

  const onDown = (x) => {
    isDown = true;
    startX = x;
    startScroll = strip.scrollLeft;
    strip.classList.add('is-dragging');
  };

  const onMove = (x) => {
    if (!isDown) return;
    const delta = x - startX;
    strip.scrollLeft = startScroll - delta;
  };

  const onUp = () => {
    if (!isDown) return;
    isDown = false;
    strip.classList.remove('is-dragging');
  };

  // Mouse
  strip.addEventListener('mousedown', (e) => onDown(e.pageX));
  window.addEventListener('mousemove', (e) => onMove(e.pageX));
  window.addEventListener('mouseup', onUp);

  // Touch
  strip.addEventListener('touchstart', (e) => onDown(e.touches[0].pageX), { passive: true });
  window.addEventListener('touchmove', (e) => onMove(e.touches[0].pageX), { passive: true });
  window.addEventListener('touchend', onUp);

  // Prevent accidental link click while dragging
  strip.addEventListener('click', (e) => {
    if (strip.classList.contains('is-dragging')) e.preventDefault();
  });

  // Optional: snap to nearest item when the user stops
  let snapTimer;
  strip.addEventListener('scroll', () => {
    clearTimeout(snapTimer);
    snapTimer = setTimeout(() => {
      const items = [...strip.querySelectorAll('.thumbnail-list__item.slider__slide')];
      if (!items.length) return;
      // Find the item whose left edge is closest to the scroll position
      const lefts = items.map((el) => el.offsetLeft);
      const pos = strip.scrollLeft;
      let nearest = lefts[0], min = Math.abs(pos - lefts[0]);
      for (let i = 1; i < lefts.length; i++) {
        const d = Math.abs(pos - lefts[i]);
        if (d < min) { min = d; nearest = lefts[i]; }
      }
      strip.scrollTo({ left: nearest, behavior: 'smooth' });
    }, 120);
  });
})();
